module.exports = __webpack_public_path__ + "static/media/121-new-zealand.e990c931.svg";